module.exports = __webpack_public_path__ + "img/1303142292.8f2afc26.jpg";